import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { Table, TableBody, TableRow, TableCell, TableHeader } from 'components/Table';
import cx from 'classnames';
import tel from 'utils/phone';
import { Button, Tag } from '@ontruck/orc';
import DriverConversationSelect from 'modules/chat/DriverConversationsSelect';
import { DRIVER_STATES } from 'components/CarrierDetails/Constants';
import { CARRIER_STATES } from 'components/CarrierDetails/Constants';
import LogCarrierNotes from 'components/LogCarrierNotes';
class DriverListContainer extends React.Component {
  render() {
    const {
      drivers = [],
      onCellClick,
      onActiveClick,
      onFilterDriver,
      intl,
      className = '',
      carrier,
      isDriverChatDisabled,
    } = this.props;

    const t = intl.messages.components.DriverList;

    const renderHeaders = () => {
      return (
        <TableHeader className="driver-list__header">
          <TableRow className="driver-list__header-row">
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell>{t.jobs}</TableCell>
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
          </TableRow>
        </TableHeader>
      );
    };

    const renderStatusTag = (driver) => {
      if (driver.status === DRIVER_STATES.banned) {
        return <Tag text={t.banned} skin="modernRed" weight="bold" size="M" />;
      }
      if (driver.status === DRIVER_STATES.not_active) {
        return <Tag text={t.not_active} skin="modernGrey" weight="bold" size="M" />;
      }
    };

    return (
      <div className={className} data-testid="driverList">
        <Table className="driver-list">
          {renderHeaders()}
          <TableBody>
            {drivers.map((driver, index) => (
              <TableRow
                key={driver.id}
                onRowClick={() => onCellClick(driver.id)}
                className={cx('driver-list__row', {
                  'driver-list__row--inactive': driver.status === DRIVER_STATES.not_active,
                })}
                dataTestId="driverListRow"
              >
                <TableCell className="driver-list__cell-name">{driver.contact_name}</TableCell>
                <TableCell>{renderStatusTag(driver)}</TableCell>
                <TableCell className="driver-list__cell-type">
                  {driver.dispatchee ? t.driver : t.manager}
                </TableCell>
                <TableCell className="driver-list__cell-jobs">
                  <Button
                    nude
                    skin="primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      onFilterDriver(driver);
                    }}
                    text={driver.shipments ? driver.shipments.toString() : '0'}
                  />
                </TableCell>
                <TableCell></TableCell>
                <TableCell>
                  {driver.status === DRIVER_STATES.not_active &&
                    onActiveClick &&
                    driver.status !== DRIVER_STATES.banned &&
                    carrier.status !== CARRIER_STATES.banned && (
                      <Button
                        link
                        onClick={(e) => {
                          e.stopPropagation();
                          onActiveClick(driver);
                        }}
                        text={t.active}
                      />
                    )}
                </TableCell>
                <TableCell>
                  <LogCarrierNotes log={driver.status_log} id={driver.id} />
                </TableCell>
                <TableCell>
                  {!isDriverChatDisabled && (
                    <DriverConversationSelect
                      driverId={driver.id}
                      isDispatchee={driver.dispatchee}
                      className="driver-list__cell-contact"
                    />
                  )}
                </TableCell>
                <TableCell>
                  <Button
                    ghost
                    skin="primary"
                    icon="phone"
                    iconPosition="left"
                    className="driver-list__phone-icon"
                    onClick={(e) => e.stopPropagation()}
                    href={tel(driver.contact_phone)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}

DriverListContainer.propTypes = {
  carrier: PropTypes.object,
  drivers: PropTypes.array,
  onCellClick: PropTypes.func,
  intl: PropTypes.any,
  className: PropTypes.string,
  onActiveClick: PropTypes.func,
  onFilterDriver: PropTypes.func,
};

export default injectIntl(DriverListContainer);
